<template>
  <div class="impressum flex min-h-screen flex-col bg-night">
    <AppHeader />
    <main class="mx-auto w-full max-w-3xl px-4 pb-10 pt-6 sm:px-6 sm:pt-10">
      <h1 class="mb-6 font-display text-[40px] font-extrabold leading-none tracking-tight sm:mb-8 sm:text-5xl">Impressum</h1>
      
      <div class="space-y-6 break-words rounded-3xl border border-edge bg-panel p-5 leading-relaxed text-slate-300 sm:p-8">
        <section>
          <p class="mb-4">Angaben gemäß § 5 TMG</p>
        </section>

        <section>
          <p class="mb-2">
            Roman Herbstmann<br>
            Tungerloh-Capellen 3<br>
            48712 Gescher<br>
            Deutschland
          </p>
        </section>

        <section>
          <p class="mb-2">
            <strong class="text-white">Vertreten durch:</strong><br>
            Roman Herbstmann
          </p>
        </section>

        <section>
          <p class="mb-2">
            <strong class="text-white">Kontakt:</strong><br>
            Tel: +49 (0)17655401011<br>
            E-Mail: rh@rherbstmann.de
          </p>
        </section>

        <section>
          <p class="mb-2">
            <strong class="text-white">Umsatzsteuer-ID:</strong><br>
            Umsatzsteuer-Identifikationsnummer entfällt gemäß §19 Umsatzsteuergesetz
          </p>
        </section>
      </div>

      <h2 id="datenschutz" class="mb-4 mt-10 font-display text-[28px] font-extrabold leading-none tracking-tight sm:text-4xl">Datenschutz</h2>
      <div class="space-y-4 break-words rounded-3xl border border-edge bg-panel p-5 leading-relaxed text-slate-300 sm:p-8">
        <section>
          <p class="mb-2"><strong class="text-white">Besucherstatistik</strong></p>
          <p>
            Zur Auswertung der Seitenaufrufe nutzen wir Umami, das wir selbst auf unserem eigenen Server betreiben.
            Umami setzt keine Cookies. Erfasst werden die aufgerufene Seite, die verweisende Seite, Browser,
            Betriebssystem, Gerätetyp, Bildschirmgröße, Sprache und der ungefähre Standort.
          </p>
          <p class="mt-2">
            Deine IP-Adresse wird nicht gespeichert. Sie wird aber kurz verarbeitet, um den ungefähren Standort zu
            ermitteln und zusammen mit den Browserangaben eine pseudonyme Besucherkennung (Hash) zu bilden. Die Daten
            sind damit pseudonym, nicht anonym, und werden nicht an Dritte weitergegeben.
          </p>
          <p class="mt-2">
            Rechtsgrundlage ist unser berechtigtes Interesse an einer einfachen Reichweitenmessung
            (Art. 6 Abs. 1 lit. f DSGVO). Du kannst dem jederzeit über die unten genannte E-Mail-Adresse widersprechen.
          </p>
        </section>
        <section>
          <p class="mb-2"><strong class="text-white">Eingebettete Inhalte</strong></p>
          <p>
            Auf der Startseite kann ein Spotify-Player der Spotify AB (Schweden) geladen werden. Das passiert erst,
            wenn du zustimmst. Danach baut dein Browser eine Verbindung zu Spotify auf; dabei werden Daten wie deine
            IP-Adresse an Spotify übertragen, und Spotify kann Cookies setzen sowie Daten auch außerhalb der EU
            verarbeiten. Es gelten die
            <a
              href="https://www.spotify.com/de/legal/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              class="underline underline-offset-2 hover:text-white"
            >Datenschutzbestimmungen von Spotify</a>.
          </p>
          <p class="mt-2">
            Rechtsgrundlage ist deine Einwilligung (Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1 TDDDG). Deine Entscheidung
            merken wir uns nur in deinem Browser (localStorage). Du kannst sie jederzeit mit Wirkung für die Zukunft
            widerrufen.
          </p>
          <button
            v-if="consent"
            type="button"
            @click="revoke"
            class="mt-3 min-h-11 rounded-xl border border-edge bg-night px-4 py-2 text-sm font-semibold text-slate-100 transition-colors hover:bg-edge"
          >
            Spotify-Einwilligung widerrufen
          </button>
          <p v-else class="mt-2 text-sm text-slate-400">Aktuell hast du nicht eingewilligt, der Player wird nicht geladen.</p>
        </section>
        <section>
          <p>Fragen zum Datenschutz beantworten wir gern unter der oben genannten E-Mail-Adresse.</p>
        </section>
      </div>
    </main>
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import { useSpotifyConsent } from '@/composables/useSpotifyConsent';

const { consent, revoke } = useSpotifyConsent();
</script>
